export { default } from './ValidateEmail.container';
export { default as ValidateEmail } from './ValidateEmail';
export { default as ValidateEmailDuringActivate } from './ValidateEmailDuringActivate.container';
